/* eslint-disable class-methods-use-this */
import {decorate, observable} from 'mobx';
import User from "../Models/User";
import Logger from "../Logger/Logger";

const logger = Logger.Create("UserRepository");

/**
 * User Repository.
 */
export class UserRepository
{
    private blankUser: User = {
        emailAddress: "",
        password: "",
    };
    
    /**
     * The current user.
     */
    public user: User = this.blankUser;

    /**
     * The token.
     */
    public token: string = "";
    
    
    
    /**
     * Updates user details.
     * @param user The user clients.
     */
    public updateUser(user: User): void
    {
        this.user = user;
    }

    /**
     * Clears the user.
     */
    public removeUserDetails(): void
    {
        this.user = this.blankUser;
        this.token = "";
    }

    /**
     * Updates the token.
     * @param token The token.
     */
    public updateToken(token: string): void
    {
        this.token = `${token}`;
    }
    
    /**
     * Returns if the user is logged in.
     */
    public isLoggedIn(): boolean
    {
        return this.token.trim() !== "";
    }
}

decorate(UserRepository, {
    user: observable,
    token: observable,
});

export const userRepository = new UserRepository();
